// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__rUjAH","open":"Menu_open__1UrIC","options":"Menu_options__1lCms"};